import React from 'react'

export default function ScrollButton() {
  return (
    <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-50">
        <button
            onClick={() => {
            document
                .getElementById("scroll-target")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="w-14 h-14 rounded-full border-2 border-sky-200 flex items-center justify-center animate-bounce backdrop-blur-md"
        >
            <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-black"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
            />
            </svg>
        </button>
    </div>

  )
}
